// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sfJC","colBig":"styles_colBig__1lP_E","colSmall":"styles_colSmall__1wCbQ"};